import { Routes } from '@angular/router';

export const calcPrimeRoutes: Routes = [
  {
    path: 'calcu-prime',
    loadComponent: () =>
      import('./calculator.prime.component').then((c) => c.CalculatorPrimeComponent),
  },
];
